import * as React from 'react';
import type { ForwardRefComponent } from '@fluentui/react-components';
import { renderReferenceList_unstable } from './renderReferenceList';
import { useReferenceList_unstable } from './useReferenceList';
import { useReferenceListStyles_unstable } from './useReferenceListStyles.styles';
import { useReferenceListContextValues_unstable } from './useReferenceListContextValues';
import type { ReferenceListProps } from './ReferenceList.types';

export const ReferenceList: ForwardRefComponent<ReferenceListProps> = React.forwardRef((props, ref) => {
  const state = useReferenceList_unstable(props, ref);
  const referenceListContextValues = useReferenceListContextValues_unstable(state);

  useReferenceListStyles_unstable(state);

  return renderReferenceList_unstable(state, referenceListContextValues);
});

ReferenceList.displayName = 'ReferenceList';
